import { Box } from "@mui/material"
import Animated from '../../assets/images/animated/bouncing-circles.svg'

const LoadingAnimatedIcon = () => {
    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', height: '70vh', alignItems: 'center' }}>
            <Box>
                <img style={{ width: 150, height: 150 }} src={Animated} alt="" />
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'row-reverse' }}>
                <img style={{ width: 150, height: 150, transform: 'scaleX(-1)' }} src={Animated} alt="" />
            </Box>
        </Box>
    )
}
export default LoadingAnimatedIcon